<div class="simplified-nav hidden lg:block" [class.no-menu]="showMenu === false">
  @if (simplifiedNav(); as nav) {
    <div class="nav-inner">
      <div class="nav-left">
        @if (showLogoHref) {
          <a class="nav-logo-link" href="/">
            <img
              src="https://dec-mkt.imgix.net/images/logo.png?auto=compress,format"
              height="36"
              width="220"
              data-test="decLogo"
              alt="DriversEd Logo (Header)"
            />
          </a>
        } @else {
          <a class="nav-logo-link" href="/">
            <img src="https://dec-mkt.imgix.net/images/alternate-logo.png?auto=compress,format" alt="Alternate Logo (Header)" />
          </a>
        }
        @if (secondaryLogo) {
          <img class="addl-logo" [src]="secondaryLogo.url" alt="{{ secondaryLogo.alt }} (Header)" />
        }
      </div>

      <nav class="nav-center" data-test="headerMenu">
        @if (nav.driversEd.items.length) {
          <div class="nav-item has-dropdown" [class.open]="openDropdown() === 'driversEd'">
            <button
              type="button"
              class="nav-btn"
              (click)="toggleDropdown('driversEd', $event)"
              aria-haspopup="true"
              [attr.aria-expanded]="openDropdown() === 'driversEd'"
              data-test="driversEdToggle"
            >
              {{ nav.driversEd.label }} <span class="caret"></span>
            </button>
            <div class="dropdown">
              @for (link of nav.driversEd.items; track link.href) {
                <a href="{{ link.href }}">{{ link.text }}</a>
              }
            </div>
          </div>
        }

        @if (nav.trafficSchool.href) {
          <a class="nav-btn nav-link" href="{{ nav.trafficSchool.href }}">{{ nav.trafficSchool.label }}</a>
        }

        @if (nav.testPrep.href) {
          <a class="nav-btn nav-link" href="{{ nav.testPrep.href }}">{{ nav.testPrep.label }}</a>
        }

        @if (nav.more.items.length) {
          <div class="nav-item has-dropdown" [class.open]="openDropdown() === 'more'">
            <button
              type="button"
              class="nav-btn"
              (click)="toggleDropdown('more', $event)"
              aria-haspopup="true"
              [attr.aria-expanded]="openDropdown() === 'more'"
              data-test="moreToggle"
            >
              {{ nav.more.label }} <span class="caret"></span>
            </button>
            <div class="dropdown">
              @for (link of nav.more.items; track link.href) {
                <a href="{{ link.href }}">{{ link.text }}</a>
              }
            </div>
          </div>
        }
      </nav>

      <div class="nav-right">
        <div class="nav-item has-dropdown state-pill" [class.open]="openDropdown() === 'state'">
          <button
            type="button"
            class="state-btn"
            (click)="toggleDropdown('state', $event)"
            aria-haspopup="true"
            [attr.aria-expanded]="openDropdown() === 'state'"
            data-test="stateSelector"
          >
            <span class="pin" aria-hidden="true">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="#9ca3af">
                <path
                  d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                />
              </svg>
            </span>
            <span data-test="stateLabel">{{ stateLabel() }}</span>
            <span class="caret"></span>
          </button>
          <div class="dropdown state-dropdown" data-test="stateListDropdown">
            @for (item of stateSelectionList; track item.href) {
              <a href="{{ item.href }}" (click)="selectState(item)">{{ item.text }}</a>
            }
          </div>
        </div>

        <a class="help-link" href="/support/" data-test="helpLink">Help Center</a>
        <a class="login-btn" href="https://app.driversed.com/user/signin/" data-test="loginButton">Log In</a>
      </div>
    </div>
  }
</div>

@if (showMenu) {
  <!-- EPS-4439: `contents` (not `block`) is required, same reason as the head
  wrapper in template-single.component.html (EPS-3771). A `display: block` host
  wraps `.mh` exactly — the slide-in panel beside it is `position: fixed` and so
  contributes no height — which makes the host the sticky containing block for
  `.mh` and leaves it a zero-length sticky range: it scrolled away with the page
  while the countdown banner stayed pinned. `contents` removes the host from the
  box tree so `.mh` resolves against the same tall ancestor the desktop
  `.simplified-nav` already sticks within. `lg:hidden` still hides it on desktop.
  Do not target this host for layout/styling. -->
  <dec-mobile-menu
    class="contents lg:hidden"
    [simplifiedNav]="simplifiedNav()"
    [stateLabel]="stateLabel()"
  ></dec-mobile-menu>
}
